export default __webpack_public_path__ + "e3b69ecc29e80cb7a2372cb6e89655e1.png";